import DateRangeIcon from "@mui/icons-material/DateRange";
import { InputAdornment } from "@mui/material";

const CalendarIconAdornment = ({ iconSize }) => {
  return (
    <InputAdornment position="end">
      <DateRangeIcon fontSize={iconSize ?? "small"} className="calendar-icon" />
    </InputAdornment>
  );
};

export default CalendarIconAdornment;
